import { createContext, useContext } from 'react';

import type { TLayer } from './ModalContext';

export const ModalLayerContext = createContext<TLayer | null>(null);

export const useModalLayer = () => useContext(ModalLayerContext);
